/**
 * Office editor registration — provider switch (#617).
 *
 * Collabora is the DEFAULT office engine. VITE_OFFICE_PROVIDER switches the whole
 * deployment to a DocsAPI-family provider — `onlyoffice` or its `eurooffice` fork
 * (§10) — both served by the SAME registration/adapter (one active at a time). The
 * WOPI backend (features/collab/server/wopi-*.ts) is provider-agnostic; the DocsAPI
 * routes (/callback, /forcesave) coexist with Collabora's PutFile handling and fire
 * only for a DocsAPI engine (IS_DOCSAPI).
 */
//
// SYNCHRONOUS on purpose. This used to be a fire-and-forget `import()` of the
// chosen module, which left a window in which `getEditorForExtension('docx')`
// answered null — harmless-looking in the drive (a re-render usually comes), but
// the share view resolves its editor ONCE from the same registry (I111) and a
// null there means "unregistered binary" → the raw-file fallback. Both modules
// only register lazy() components, so importing both statically costs nothing:
// the editor chunks still load on first mount.
import { IS_DOCSAPI_PROVIDER } from './docsapi-provider.js'
import { registerDocsApiEditors } from './onlyoffice-registration.js'
import { registerCollaboraEditors } from './collabora-registration.js'

if (IS_DOCSAPI_PROVIDER) {
  registerDocsApiEditors()
} else {
  registerCollaboraEditors()
}
